import AppRoot from './app-root.component';
import { connect } from 'react-redux';
import { fetchCategory } from "./../../api/category/categoryAction";
import { changeAddToFalse, updateCart, fetchCart, deleteCart } from "./../../api/cart/cartAction";

const mapDispatchToProps = {
    fetchCategory,
    changeAddToFalse,
    updateCart,
    fetchCart,
    deleteCart
};

const mapStateToProps = state => ({
    categories: state.categoryPage.categories,
    isLoggedIn: state.userPage.isLoggedIn,
    user: state.userPage.loggedUser,
    cart: state.cartPage.cart,
    isAdded: state.cartPage.isAdded
});

export const AppRootContainer = connect(mapStateToProps, mapDispatchToProps)(AppRoot);